export default __webpack_public_path__ + "static/media/iconFirebase.22ade27d.png";